import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { BillingTab } from './BillingTab';
import { FleetTab } from './FleetTab';
import { RoutesTab } from './RoutesTab';
import { SeatsTab } from './SeatsTab';

type Tab = 'routes' | 'seats' | 'fleet' | 'billing';

export function TransportPage() {
  const { can } = useAuth();
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('routes');
  const tabs: Tab[] = [];
  if (schoolId && can('transport.view', schoolId)) tabs.push('routes', 'seats', 'fleet', 'billing');
  const active = tabs.includes(tab) ? tab : tabs[0];

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('tr.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && active && (
        <>
          <div
            role="tablist"
            aria-label={t('tr.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {tabs.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={active === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${active === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`tr.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {active === 'routes' && <RoutesTab schoolId={schoolId} />}
            {active === 'seats' && <SeatsTab schoolId={schoolId} />}
            {active === 'fleet' && <FleetTab schoolId={schoolId} />}
            {active === 'billing' && <BillingTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
